import { useCallback, useState } from 'react';
import useRequest from 'hooks/useRequest';

// Hooks que leen los endpoints de Fase 4 del backend:
//   - GET /edificios/:id/informe-anual?ano=YYYY → payload del informe anual
//   - GET /edificios/:id/paquete-dom         → payload del paquete DOM
//
// Los payloads se consumen con TemplateRenderer + template low-code
// (`informe_anual_mantenciones` o `paquete_carpeta_cero_dom`). Los consumidores
// enriquecen el payload con campos *_fmt antes de pasarlo al renderer para
// evitar issues de timezone en @react-pdf/renderer.

export function useInformeAnualEdificio() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { request } = useRequest();

  const fetchInforme = useCallback(
    async (idEdificio, ano) => {
      if (!idEdificio) return null;
      setLoading(true);
      setError(null);
      try {
        const qs = ano ? `?ano=${ano}` : '';
        return await request(`/edificios/${idEdificio}/informe-anual${qs}`, 'GET');
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [request]
  );

  return { fetchInforme, loading, error };
}

export function usePaqueteDOMEdificio() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { request } = useRequest();

  const fetchPaquete = useCallback(
    async (idEdificio) => {
      if (!idEdificio) return null;
      setLoading(true);
      setError(null);
      try {
        return await request(`/edificios/${idEdificio}/paquete-dom`, 'GET');
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [request]
  );

  return { fetchPaquete, loading, error };
}
